export class TipoMedicionBO {
   
    public idcompania: string;
    public idMedicion: string;
    public descripcion: string;
    public valorLogico: boolean;
    public estado: string;

}